import { FunctionComponent } from 'react'
import { useBreadcrumbs } from '~/hooks/useBreadcrumbs'
import { PureAdmAdUnitImportPage } from './PureAdmAdUnitImportPage'
import { useAdUnitsImport } from './useAdUnitsImport'

export const AdmAdUnitImportPage: FunctionComponent = () => {
  // Hooks
  const breadcrumbs = useBreadcrumbs()
  const { adUnitsFile, validationResults, isDownloading, isValidating, isCreating, handleBackClick, handleFileChange, handleDownload, handleDelete, handleValidateFile, handleCreate } =
    useAdUnitsImport()

  return (
    <PureAdmAdUnitImportPage
      breadcrumbs={breadcrumbs}
      filename={adUnitsFile?.name}
      validationResults={validationResults}
      isDownloading={isDownloading}
      isValidating={isValidating}
      isCreating={isCreating}
      onBackClick={handleBackClick}
      onChange={handleFileChange}
      onValidate={handleValidateFile}
      onDownload={handleDownload}
      onDelete={handleDelete}
      onCreate={handleCreate}
    />
  )
}
